import { render } from "./AppSpinnerIcon.vue?vue&type=template&id=472a3fa6"
const script = {}

import "./AppSpinnerIcon.vue?vue&type=style&index=0&id=472a3fa6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__